import CommonPopover from "@/components/Popover";
import { isOwnProperty } from "@/utils/common";
import React from "react";
import { useCallback, useEffect, useRef, useState } from "react";


const prefix = "download-list";

const desTips = (str: string) => {
  return <div className="download-list-desc-tips">{str}</div>;
};

const DesPopover = (props: any) => {
  const { detail } = props;
  // console.log("DesPopover render", detail);
  const elementId= "des-popover-" + detail.id;
  const linesRef=useRef<number>(1);
  const [popoverProps, setPopoverProps] = useState<any>({
    trigger: "hover",
    placement: "bottomRight",
    arrow: false,
    content: desTips(detail.description),
    open:false
  });

  const changePopoverOpenValue=useCallback(
    /**
     * 更改popover的open属性
     * @param isNeedOpen 是否需要open属性
     */
    (isNeedOpen:boolean)=>{
    setPopoverProps((val: any) => {
      const newVal={
        ...val
      }
      if(isNeedOpen){
        if(isOwnProperty( newVal,'open')){
          delete newVal.open;
        }
      }else{
        newVal.open=false;
      }
      return newVal;
    });
  },[])
  useEffect(() => {
    const el = document.getElementById(elementId);
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((ele) => {
        if(ele.target.id==elementId){
          if (el) {
            const lineHeight = parseInt(getComputedStyle(el).lineHeight);
            const height = ele.contentRect.height;
            const lineCount = Math.floor(height / lineHeight);
            if(lineCount!=linesRef.current){
              linesRef.current=lineCount;
              changePopoverOpenValue(lineCount > 1);
            }
          }
        }
      })
      
    });
    if(el){
      resizeObserver.observe(el);
    }
    
    return () => {
      resizeObserver.disconnect();
      console.log("resizeObserver disconnect");
    };
  }, []);
  return (
    <CommonPopover {...popoverProps}>
      <div className={`${prefix}-left-desc `}>
        <span id={elementId} className="two-line-ellipsis">
          {detail.description}
        </span>
      </div>
    </CommonPopover>
  );
};
export default React.memo(DesPopover);